import api from '../API';
import { Account } from '../types';

export default {
  async find(id: string): Promise<Account> {
    return api.get(`accounts/${id}`).then(res => res.data);
  },
};
